// SEO配置文件 - 统一管理所有页面的SEO信息
export const seoConfig = {
  // 网站默认信息
  defaultSeo: {
    siteName: "CHIHUI Mandarin Hub",
    siteUrl: "https://www.chihuimandarin.com",
    defaultTitle: "Learn Chinese in Singapore | Professional Mandarin Classes | CHIHUI Mandarin Hub",
    defaultDescription: "Learn Chinese language with CHIHUI Mandarin Hub - Singapore's top Chinese learning institute. Professional Mandarin classes for beginners, business Chinese courses, online Chinese lessons, and cultural programs. Expert native instructors help you master Chinese language skills.",
    defaultKeywords: "learn Chinese in Singapore, learn Chinese language, learn Chinese for beginners, Mandarin classes Singapore, Chinese language course Singapore, learn Chinese online, Chinese tutoring Singapore, Mandarin lessons Singapore, Chinese language school Singapore, learn Chinese characters",
    defaultOgImage: "https://www.chihuimandarin.com/static/media/logo_foot.jpg",
    defaultTwitterImage: "https://www.chihuimandarin.com/static/media/logo_foot.jpg",
    defaultInstagramImage: "https://www.chihuimandarin.com/static/media/logo_ch.jpg",
    author: "CHIHUI Mandarin Hub",
    locale: "en_SG",
    type: "website",
    imageWidth: "1200",
    imageHeight: "630",
    twitterImageWidth: "1200",
    twitterImageHeight: "600",
    instagramImageWidth: "1080",
    instagramImageHeight: "1080"
  },

  // 页面特定SEO配置
  pages: {
    home: {
      title: "Learn Chinese in Singapore | Best Mandarin Classes for Beginners & Professionals | CHIHUI Mandarin",
      description: "Want to learn Chinese language? CHIHUI Mandarin Hub offers the best Chinese classes in Singapore. Learn Chinese for beginners, business Mandarin, online Chinese lessons, and cultural programs. Start your Chinese learning journey with expert native instructors today!",
      keywords: "learn Chinese in Singapore, learn Chinese language, learn Chinese for beginners, learn Chinese online, Mandarin classes Singapore, Chinese language course Singapore, best Chinese classes Singapore, Chinese tutoring Singapore, learn Chinese characters, Mandarin lessons Singapore, Chinese language school Singapore",
      path: "/"
    },

    aboutus: {
      title: "About CHIHUI Mandarin | Leading Chinese Language School in Singapore",
      description: "Discover why CHIHUI Mandarin Hub is Singapore's trusted choice for learning Chinese language. Meet our expert native Mandarin instructors, explore our proven teaching methods, and learn how we help students master Chinese for beginners to advanced levels.",
      keywords: "about CHIHUI Mandarin, learn Chinese in Singapore, Chinese language school Singapore, Mandarin teachers Singapore, learn Chinese for beginners, Chinese education Singapore, best Chinese institute Singapore, native Chinese instructors",
      path: "/aboutus"
    },

    courses: {
      title: "Learn Chinese Language Courses Singapore | Online & Offline Mandarin Classes | CHIHUI Mandarin",
      description: "Comprehensive Chinese language courses in Singapore for all levels. Learn Chinese for beginners, business Mandarin, exam preparation (HSK/PSLE), cultural programs, and learn Chinese online. Expert instruction with flexible scheduling.",
      keywords: "learn Chinese language, Chinese courses Singapore, learn Chinese in Singapore, learn Chinese for beginners, learn Chinese online, Mandarin classes Singapore, business Chinese course, HSK preparation Singapore, PSLE Chinese Singapore, Chinese exam preparation, learn Chinese characters",
      path: "/courses"
    },

    'business-chinese': {
      title: "Learn Business Chinese Singapore | Professional Mandarin Course for Working Adults | CHIHUI Mandarin",
      description: "Learn business Chinese language skills for professional success in Singapore. Comprehensive business Mandarin course with HSK/BCT preparation, industry vocabulary, and cultural training. Perfect for working professionals who want to learn Chinese for career advancement.",
      keywords: "learn business Chinese, business Chinese Singapore, learn Chinese for professionals, professional Mandarin course Singapore, business Chinese language, HSK BCT preparation Singapore, corporate Chinese training Singapore, learn Chinese adults Singapore",
      path: "/business-chinese"
    },

    'exam-preparation': {
      title: "Learn Chinese for Exams Singapore | HSK, PSLE, O Level Chinese Preparation | CHIHUI Mandarin",
      description: "Learn Chinese language for exam success in Singapore. Expert Chinese exam preparation for HSK, PSLE, O Level, A Level, and IB Chinese. Proven strategies and comprehensive materials to help you master Chinese language examinations.",
      keywords: "learn Chinese for exams, Chinese exam preparation Singapore, HSK preparation Singapore, PSLE Chinese tuition Singapore, learn Chinese for HSK, O level Chinese Singapore, A level Chinese Singapore, IB Chinese Singapore, Chinese examination coaching Singapore",
      path: "/exam-preparation"
    },

    'speech-eloquence': {
      title: "Learn Chinese Speech & Public Speaking Singapore | Mandarin Eloquence Training | CHIHUI Mandarin",
      description: "Learn Chinese speech and eloquence skills in Singapore. Develop confident Mandarin speaking abilities for presentations, competitions, and public speaking. Professional Chinese language training to master pronunciation and oratory skills.",
      keywords: "learn Chinese speech, Chinese speech training Singapore, learn Chinese speaking, Mandarin eloquence classes Singapore, public speaking Chinese Singapore, learn Chinese pronunciation, Chinese oratory training Singapore, Mandarin speaking skills",
      path: "/speech-eloquence"
    },

    'immersion-programs': {
      title: "Learn Chinese Cultural Immersion Singapore | Chinese Language & Calligraphy Programs | CHIHUI Mandarin",
      description: "Learn Chinese language and culture through immersive programs in Singapore. Learn Chinese calligraphy, traditional arts, cooking, and language skills. 6 hours daily intensive Chinese learning experience perfect for beginners and cultural enthusiasts.",
      keywords: "learn Chinese cultural immersion, Chinese immersion programs Singapore, learn Chinese calligraphy, learn Chinese culture Singapore, Chinese language holiday program, learn Chinese dance Singapore, traditional Chinese arts Singapore, Chinese cooking classes Singapore, learn Chinese intensive Singapore",
      path: "/immersion-programs"
    },

    contact: {
      title: "Contact CHIHUI Mandarin | Book Free Chinese Language Trial Class Singapore",
      description: "Ready to learn Chinese language? Contact CHIHUI Mandarin Hub in Singapore to book your free trial lesson. Inquire about our Chinese courses, speak with education consultants, and start your Chinese learning journey today!",
      keywords: "contact CHIHUI Mandarin, book Chinese lesson Singapore, learn Chinese trial class Singapore, Chinese school Singapore contact, Mandarin classes inquiry Singapore, free Chinese lesson Singapore, Chinese language consultation Singapore",
      path: "/contact"
    },

    knowledge: {
      title: "How to Learn Chinese Language | Free Chinese Learning Tips & Study Guide Singapore | CHIHUI Mandarin",
      description: "Free expert guides on how to learn Chinese language effectively. Chinese learning tips for beginners, pronunciation guides, character learning strategies, and comprehensive FAQ. Accelerate your Chinese language learning journey in Singapore with proven methods.",
      keywords: "how to learn Chinese language, learn Chinese language tips, Chinese learning guide Singapore, learn Chinese for beginners tips, Chinese pronunciation guide, learn Chinese characters effectively, Chinese language FAQ, learn Chinese study methods Singapore",
      path: "/knowledge"
    }
  },

  // 生成完整的meta数据
  generateMetaData: (pageKey, customData = {}) => {
    const defaultSeo = seoConfig.defaultSeo;
    const pageSeo = seoConfig.pages[pageKey] || {};
    
    const metaData = {
      title: customData.title || pageSeo.title || defaultSeo.defaultTitle,
      description: customData.description || pageSeo.description || defaultSeo.defaultDescription,
      keywords: customData.keywords || pageSeo.keywords || defaultSeo.defaultKeywords,
      ogTitle: customData.ogTitle || pageSeo.title || defaultSeo.defaultTitle,
      ogDescription: customData.ogDescription || pageSeo.description || defaultSeo.defaultDescription,
      ogImage: customData.ogImage || pageSeo.ogImage || defaultSeo.defaultOgImage,
      twitterImage: customData.twitterImage || pageSeo.twitterImage || defaultSeo.defaultTwitterImage,
      instagramImage: customData.instagramImage || pageSeo.instagramImage || defaultSeo.defaultInstagramImage,
      ogUrl: `${defaultSeo.siteUrl}${pageSeo.path || '/'}`,
      canonicalUrl: `${defaultSeo.siteUrl}${pageSeo.path || '/'}`,
      siteName: defaultSeo.siteName,
      locale: defaultSeo.locale,
      type: defaultSeo.type,
      author: defaultSeo.author,
      imageWidth: defaultSeo.imageWidth,
      imageHeight: defaultSeo.imageHeight,
      twitterImageWidth: defaultSeo.twitterImageWidth,
      twitterImageHeight: defaultSeo.twitterImageHeight,
      instagramImageWidth: defaultSeo.instagramImageWidth,
      instagramImageHeight: defaultSeo.instagramImageHeight
    };

    return metaData;
  },

  // 生成结构化数据
  generateJsonLd: (pageKey, customData = {}) => {
    const defaultSeo = seoConfig.defaultSeo;
    const pageSeo = seoConfig.pages[pageKey] || {};
    
    const baseJsonLd = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": defaultSeo.siteName,
      "url": defaultSeo.siteUrl,
      "logo": `${defaultSeo.siteUrl}/static/media/logo_ch.jpg`,
      "description": pageSeo.description || defaultSeo.defaultDescription,
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "Singapore",
        "addressLocality": "Singapore"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Service",
        "availableLanguage": ["English", "Chinese", "Mandarin"]
      },
      "sameAs": [],
      "offers": {
        "@type": "Offer",
        "description": "Professional Chinese Language Learning Services"
      }
    };

    // 根据页面类型添加特定的结构化数据
    if (pageKey === 'business-chinese' || pageKey === 'exam-preparation' || 
        pageKey === 'speech-eloquence' || pageKey === 'immersion-programs') {
      return {
        ...baseJsonLd,
        "@type": "Course",
        "name": pageSeo.title,
        "description": pageSeo.description,
        "provider": {
          "@type": "Organization",
          "name": defaultSeo.siteName,
          "url": defaultSeo.siteUrl
        },
        "courseMode": pageKey === 'immersion-programs' ? "offline" : "blended",
        "educationalLevel": "All Levels",
        "teaches": "Chinese Language",
        "inLanguage": "zh-CN",
        "availableLanguage": ["English", "Chinese"]
      };
    }

    return baseJsonLd;
  }
};

export default seoConfig;
